import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-addons-edit-modal',
  templateUrl: './addons-edit-modal.component.html',
  styleUrls: ['./addons-edit-modal.component.css']
})
export class AddonsEditModalComponent implements OnInit {
  @Input() addons: any;
  @Output() onCloseModal = new EventEmitter<string>();
  @Output() onSave = new EventEmitter<any>();

  constructor() { }

  ngOnInit() {
  }

  onSaveAddons(evt: any) {
    this.onSave.emit(evt);
  }

  closeModal() {
    this.onCloseModal.emit();
  }
}
